<base-site-layout
    [heading]="heading() | translate"
    headerIcon="fas fa-file-invoice"
    [isDialog]="insideDialog"
    (dialogCloseClicked)="onDialogCancel()"
>
    @if (hasPdfFileAttachments() && !requiresCompanyCodeSelection()) {
        <base-site-layout-action>
            <button class="btn btn-sm btn-primary" *showOnDesktop (click)="togglePdfPreview()">
                @if (displayPdfPreview()) {
                    <em class="fas fa-eye-slash pe-1"></em>
                    {{ 'PDF Vorschau ausblenden' | translate }}
                } @else {
                    <em class="fas fa-eye pe-1"></em>
                    {{ 'PDF Vorschau' | translate }}
                }
            </button>
        </base-site-layout-action>
    }
    <div class="row justify-content-center mb-2">
        <div
            [ngClass]="{
                'col-12': !showPdfPreview() && insideDialog,
                'col-lg-8 col-md-10 col-sm-12': !showPdfPreview() && !insideDialog,
                'col': showPdfPreview(),
            }"
        >
            @if (isLoading()) {
                <div class="d-flex justify-content-center">
                    <iim-spinner color="secondary" size="medium"></iim-spinner>
                </div>
            } @else {
                @if (showCompanyCodeCard()) {
                    <div class="row mb-2">
                        <div class="col">
                            <iim-card [header]="companyCodeHeader">
                                <ng-template #companyCodeHeader>
                                    <div class="px-2">
                                        <div class="row">
                                            <div class="col">
                                                <h5 class="mb-0">
                                                    <em class="fas fa-building-columns pe-1"></em>
                                                    {{ 'Buchungskreis' | translate }}
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                                <div class="px-3 py-3">
                                    @if (companyCodeOptionsLoading()) {
                                        <div class="d-flex align-items-center text-description">
                                            <em class="fas fa-spinner fa-spin me-2"></em>
                                            {{ 'Buchungskreise' | translate }}
                                        </div>
                                    } @else {
                                        @if (companyCodeLoadFailed()) {
                                            <div class="alert alert-warning mb-0">
                                                {{ 'Fehler beim Laden der Buchungskreise' | translate }}
                                            </div>
                                        } @else if (!companyCodes().length) {
                                            <div class="alert alert-info mb-0">
                                                {{ 'Sie haben noch keine Buchungskreise angelegt' | translate }}
                                            </div>
                                        } @else if (showCompanyCodeSelection()) {
                                            <label class="form-label">{{ 'Buchungskreis' | translate }}</label>
                                            <select
                                                class="form-select"
                                                [ngModel]="selectedCompanyCodeId()"
                                                (ngModelChange)="handleCompanyCodeSelection($event)"
                                                [disabled]="companyCodeUpdating()"
                                            >
                                                <option [ngValue]="null" disabled>
                                                    {{ 'Bitte wählen Sie einen Buchungskreis aus' | translate }}
                                                </option>
                                                @for (companyCode of sortedCompanyCodeOptions(); track companyCode.id) {
                                                    <option [ngValue]="companyCode.id">
                                                        {{ companyCode.label }}
                                                    </option>
                                                }
                                            </select>
                                            @if (companyCodeUpdating()) {
                                                <div class="d-flex align-items-center text-description mt-2">
                                                    <em class="fas fa-spinner fa-spin me-2"></em>
                                                    {{ 'Speichern' | translate }}
                                                </div>
                                            }
                                            @if (requiresCompanyCodeSelection()) {
                                                <div class="alert alert-danger mt-3 mb-0">
                                                    {{ 'Bitte wählen Sie zuerst einen Buchungskreis aus' | translate }}
                                                </div>
                                            }
                                        } @else {
                                            <div>
                                                <div class="text-description mb-1">
                                                    {{ 'Buchungskreis' | translate }}
                                                </div>
                                                <div class="fw-bold">
                                                    {{ selectedCompanyCodeLabel() }}
                                                </div>
                                            </div>
                                        }
                                    }
                                </div>
                            </iim-card>
                        </div>
                    </div>
                }
                @if (!requiresCompanyCodeSelection()) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="headCardHeader">
                            <ng-template #headCardHeader>
                                <h5>
                                    <em class="fas fa-clock-rotate-left pe-1"></em>
                                    {{ 'Kopfdaten' | translate }}
                                </h5>
                            </ng-template>
                            <form [formGroup]="form.controls.head">
                                <div class="col">
                                    <separator>
                                        <em class="fas fa-building pe-1"></em>
                                        {{ 'Abteilung' | translate }}
                                    </separator>
                                    <div class="row mb-2">
                                        <div class="col">
                                            @if (invoice()?.department?.name) {
                                                <div
                                                    [ngClass]="{
                                                        'scale--hover shadow--hover cursor-pointer': !fixedDepartment(),
                                                    }"
                                                    class="supplier-display"
                                                    [title]="'Abteilung bearbeiten' | translate"
                                                    (click)="selectDepartmant()"
                                                >
                                                    <em class="fas fa-building pe-1"></em>
                                                    <span>{{ invoice()?.department?.name }}</span>
                                                    @if (!fixedDepartment()) {
                                                        <em class="fas fa-pen edit-icon"></em>
                                                    }
                                                </div>
                                            } @else {
                                                <div
                                                    class="supplier-display cursor-pointer scale--hover shadow--hover"
                                                    [ngClass]="{
                                                        'bg-light border-danger':
                                                            invoiceSettings()?.departmentRequired &&
                                                            !invoice()?.department?.index,
                                                        'bg-light': !(
                                                            invoiceSettings()?.departmentRequired &&
                                                            !invoice()?.department?.index
                                                        ),
                                                    }"
                                                    (click)="selectDepartmant()"
                                                >
                                                    <span class="text-description">
                                                        {{ 'Keine Abteilung ausgewählt' | translate }}
                                                        @if (invoiceSettings()?.departmentRequired) {
                                                            <span class="text-danger">*</span>
                                                        }
                                                    </span>
                                                    <em class="fas fa-pen edit-icon"></em>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <separator>
                                        <em class="fas fa-truck pe-1"></em>
                                        {{ 'Lieferant' | translate }}
                                    </separator>
                                    <div class="row mb-2">
                                        <div class="col">
                                            @if (invoice()?.supplier?.id && invoice()?.supplier.name) {
                                                <div
                                                    [ngClass]="{
                                                        'scale--hover shadow--hover cursor-pointer':
                                                            !fixedSuppler() && !showReceiptEditingRestrictionNotice(),
                                                    }"
                                                    class="supplier-display"
                                                    [title]="'Lieferant bearbeiten' | translate"
                                                    (click)="!showReceiptEditingRestrictionNotice() ? selectSupplier() : null"
                                                >
                                                    <em class="fas fa-truck pe-1"></em>
                                                    <span>
                                                        {{
                                                            invoice()?.supplier.name || ''
                                                                | supplierDisplayName: invoice()?.supplier.supplierNumber
                                                        }}
                                                    </span>
                                                    @if (!fixedSuppler() && !showReceiptEditingRestrictionNotice()) {
                                                        <em class="fas fa-pen edit-icon"></em>
                                                    }
                                                </div>
                                            } @else {
                                                <div
                                                    class="supplier-display cursor-pointer scale--hover shadow--hover bg-light border-danger"
                                                    (click)="!showReceiptEditingRestrictionNotice() ? selectSupplier() : null"
                                                >
                                                    <span class="text-description">
                                                        {{ 'Kein Lieferant ausgewählt' | translate }}
                                                        <span class="text-danger">*</span>
                                                    </span>
                                                    <em class="fas fa-pen edit-icon"></em>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <separator>
                                        {{ 'Informationen' | translate }}
                                    </separator>
                                    <div class="row mb-2">
                                        <div class="col-md-6 col-sm-12">
                                            <label #invoiceNumberLabel class="fw-bold">
                                                {{ 'Rechnungsnummer' | translate }}
                                            </label>
                                            <input
                                                errorHighlight
                                                mark-required
                                                [label]="invoiceNumberLabel"
                                                class="form-control"
                                                formControlName="invoiceNumber"
                                                [placeholder]="'Rechnungsnummer' | translate"
                                            />
                                            <div class="mt-1">
                                                @if (
                                                    form.controls.head.controls.invoiceNumber.hasError('required') &&
                                                    form.controls.head.controls.invoiceNumber.touched
                                                ) {
                                                    <span class="validation-error-indicator">
                                                        <em class="fas fa-square-xmark pe-1"></em>
                                                        {{ 'Dies ist ein Pflichtfeld' | translate }}
                                                    </span>
                                                }
                                                @if (
                                                    form.controls.head.controls.invoiceNumber.hasError(
                                                        InvoiceNumberValidatorService.invoiceNumberExistsErrorName
                                                    )
                                                ) {
                                                    <span class="validation-error-indicator">
                                                        <em class="fas fa-square-xmark pe-1"></em>
                                                        {{
                                                            invoiceNumberErrorMessages[
                                                                InvoiceNumberValidatorService
                                                                    .invoiceNumberExistsErrorName
                                                            ] | translate
                                                        }}
                                                    </span>
                                                }
                                                @if (
                                                    form.controls.head.controls.invoiceNumber.hasError(
                                                        InvoiceNumberValidatorService.invoiceNumberInvalidFormatErrorName
                                                    )
                                                ) {
                                                    <span class="validation-error-indicator">
                                                        <em class="fas fa-square-xmark pe-1"></em>
                                                        {{
                                                            invoiceNumberErrorMessages[
                                                                InvoiceNumberValidatorService
                                                                    .invoiceNumberInvalidFormatErrorName
                                                            ] | translate
                                                        }}
                                                    </span>
                                                }
                                                @if (
                                                    form.controls.head.controls.invoiceNumber.hasError(
                                                        InvoiceNumberValidatorService.invoiceNumberInvalid
                                                    )
                                                ) {
                                                    <span class="text-danger">
                                                        <em class="fas fa-square-xmark pe-1"></em>
                                                        {{
                                                            invoiceNumberErrorMessages[
                                                                InvoiceNumberValidatorService.invoiceNumberInvalid
                                                            ] | translate
                                                        }}
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md col-sm-12">
                                            <label class="fw-bold">
                                                {{ 'Rechnungsdatum' | translate }}
                                                <span class="text-danger fw-bold">*</span>
                                            </label>
                                            <iim-datepicker
                                                errorIndicator
                                                [isRequired]="true"
                                                [maxDate]="maxDate"
                                                [showDeleteButton]="false"
                                                formControlName="documentDate"
                                                [placeholder]="'Rechnungsdatum' | translate"
                                            ></iim-datepicker>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <label class="fw-bold">
                                                {{ 'Fälligkeitsdatum' | translate }}
                                                <span class="text-danger fw-bold">*</span>
                                            </label>
                                            <iim-datepicker
                                                errorIndicator
                                                [isRequired]="true"
                                                [showDeleteButton]="true"
                                                formControlName="paymentUntil"
                                                [placeholder]="'Fälligkeitsdatum' | translate"
                                            ></iim-datepicker>
                                        </div>
                                    </div>
                                    <div class="row mb-2">
                                        <div class="col-md-6 col-sm-12">
                                            <label class="fw-bold">
                                                {{ 'Währung' | translate }}
                                            </label>
                                            <iim-advanced-autocomplete [showLabel]="false" formControlName="currency">
                                                @for (currency of activeCurrencies(); track currency) {
                                                    <iim-autocomplete-option [value]="currency">
                                                        {{ currency.valueDisplay }}
                                                    </iim-autocomplete-option>
                                                }
                                            </iim-advanced-autocomplete>
                                        </div>
                                    </div>
                                    <separator>{{ 'Optionale Felder' | translate }}</separator>
                                    <div class="row mb-2">
                                        <div class="col-md-6 col-sm-12 d-none">
                                            <label class="fw-bold">
                                                {{ 'Zahlungsdatum' | translate }}
                                            </label>
                                            <iim-datepicker
                                                errorIndicator
                                                [showDeleteButton]="true"
                                                formControlName="paymentDate"
                                                [placeholder]="'Zahlungsdatum' | translate"
                                            ></iim-datepicker>
                                        </div>
                                        <div class="col-md-6 col-sm-12">
                                            <label #remarkLabel class="fw-bold">
                                                {{ 'Buchungsvermerk' | translate }}
                                            </label>
                                            <textarea
                                                formControlName="remark"
                                                [placeholder]="'Buchungsvermerk' | translate"
                                                errorIndicator
                                                class="form-control"
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </iim-card>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="invoiceAddressCardHeader">
                            <ng-template #invoiceAddressCardHeader>
                                <div class="col">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <h5>
                                                <em class="fas fa-location-pin pe-1"></em>
                                                {{ 'Rechnungsadresse' | translate }}
                                            </h5>
                                        </div>
                                        <div class="col-auto">
                                            <button
                                                class="btn btn-outline-dark"
                                                [disabled]="requiresCompanyCodeSelection() || companyCodeUpdating()"
                                                [class.border-danger]="!invoice()?.invoiceAddress"
                                                (click)="changeAddress()"
                                            >
                                                <em class="fas fa-pen"></em>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="col">
                                @if (invoice()?.invoiceAddress) {
                                    <company-address
                                        [companyAddress]="invoice()?.invoiceAddress?.companyAddress"
                                    ></company-address>
                                } @else {
                                    <div class="alert alert-danger">
                                        {{ 'Noch keine Rechnungsadresse ausgewählt' | translate }}
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="itemsCardHeader" [footer]="itemsCardFooter">
                            <ng-template #itemsCardHeader>
                                <div class="row">
                                    <div class="col">
                                        <h5>
                                            <em class="fas fa-file-lines pe-1"></em>
                                            {{ 'Positionen' | translate }}
                                        </h5>
                                    </div>
                                    @if (form.controls.items.controls.length > 0) {
                                        <div class="col-auto align-items-right mt-1">
                                            <button
                                                class="btn btn-outline-dark me-2"
                                                [disabled]="receiptBasedAccountingFieldsReadOnly()"
                                                (click)="setAllAccountings()"
                                            >
                                                <em class="fas fa-file-invoice-dollar"></em>
                                                {{ 'Für alle Kontierungen setzen' | translate }}
                                            </button>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                            <div class="col">
                                @if (showReceiptEditingRestrictionNotice()) {
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="alert alert-info m-0">
                                                @if (receiptBasedAccountingFieldsReadOnly()) {
                                                    <div>
                                                        {{
                                                            'Kontierungsfelder sind bei dieser Rechnung durch die Mandanteneinstellung schreibgeschützt.'
                                                                | translate
                                                        }}
                                                    </div>
                                                }
                                                @if (receiptBasedPriceFieldsReadOnly()) {
                                                    <div>
                                                        {{
                                                            'Preis-, Steuer- und Zusatzkostenfelder sind bei dieser Rechnung durch die Mandanteneinstellung schreibgeschützt.'
                                                                | translate
                                                        }}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (form.controls.items.controls.length === 0) {
                                    <div class="row mb-3">
                                        <div class="col">
                                            <div class="alert alert-danger m-0">
                                                <em class="fas fa-exclamation-triangle pe-1"></em>
                                                {{ 'Noch keine Positionen hinzugefügt' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                } @else {
                                    @for (
                                        itemGroup of form.controls.items.controls;
                                        track itemGroup.controls.id?.value ?? i;
                                        let i = $index
                                    ) {
                                        <div [formGroup]="itemGroup">
                                            <div class="row mx-auto mb-3">
                                                <div class="article w-100 position-relative">
                                                    <div
                                                        class="remove-position-btn border-danger scale--hover shadow--hover"
                                                        (click)="removeItem(i)"
                                                    >
                                                        <em class="fas fa-trash text-danger"></em>
                                                    </div>
                                                    <div class="col">
                                                        <div class="row mb-2 align-items-start">
                                                            <div class="col">
                                                                <label class="fw-bold" #nameLabel>
                                                                    {{ 'Name' | translate }}
                                                                </label>
                                                                <input
                                                                    errorIndicator
                                                                    mark-required
                                                                    [label]="nameLabel"
                                                                    formControlName="name"
                                                                    [placeholder]="'Name' | translate"
                                                                    class="form-control"
                                                                />
                                                            </div>
                                                            <div class="col-auto">
                                                                @if (itemGroup.value.deliveryRelation; as relation) {
                                                                    <div
                                                                        class="receipt-preview scale--hover shadow--hover cursor-pointer"
                                                                        (click)="
                                                                            openReceipt(relation.deliveryReceiptId)
                                                                        "
                                                                    >
                                                                        <div class="preview-icon">
                                                                            <em class="fas fa-info-circle"></em>
                                                                        </div>
                                                                        @if (!showReceiptEditingRestrictionNotice()) {
                                                                            <div class="actions">
                                                                                <div
                                                                                    class="edit text-primary hoverable"
                                                                                    [title]="
                                                                                        'Lieferschein Verknüpfung bearbeiten'
                                                                                            | translate
                                                                                    "
                                                                                    (click)="
                                                                                        $event.preventDefault();
                                                                                        $event.stopPropagation();
                                                                                        editDeliveryRelation(i)
                                                                                    "
                                                                                    matRipple
                                                                                >
                                                                                    <em class="fas fa-pen"></em>
                                                                                </div>
                                                                                <div
                                                                                    class="remove text-danger hoverable"
                                                                                    [title]="
                                                                                        'Lieferschein Verknüpfung löschen'
                                                                                            | translate
                                                                                    "
                                                                                    (click)="
                                                                                        $event.preventDefault();
                                                                                        $event.stopPropagation();
                                                                                        removeDeliveryRelation(i)
                                                                                    "
                                                                                    matRipple
                                                                                >
                                                                                    <em class="fas fa-trash"></em>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                        <div class="font-10 fw-bold">
                                                                            <em class="iim iim-delivery pe-1"></em>
                                                                            {{ 'Lieferschein' | translate }}
                                                                        </div>
                                                                        <div>
                                                                            <strong>{{ 'Nummer' | translate }}:</strong>
                                                                            <span copyToClipboard>
                                                                                {{ relation.deliveryReceiptNumber }}
                                                                            </span>
                                                                        </div>
                                                                        <div>
                                                                            <strong>
                                                                                {{ 'Position' | translate }}:
                                                                            </strong>
                                                                            {{ relation.deliveryItemPosition }}
                                                                        </div>
                                                                        @if (
                                                                            getSupplierNameForDeliveryRelation(
                                                                                relation.deliveryReceiptId
                                                                            )
                                                                        ) {
                                                                            <div>
                                                                                <strong>
                                                                                    {{ 'Lieferant' | translate }}:
                                                                                </strong>
                                                                                {{
                                                                                    getSupplierNameForDeliveryRelation(
                                                                                        relation.deliveryReceiptId
                                                                                    )
                                                                                }}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                } @else if (!itemGroup.controls.orderRelation.value) {
                                                                    <!-- An order link excludes a receipt link, like a receipt link excludes an order link. -->
                                                                    <div
                                                                        class="receipt-preview"
                                                                        [class.disabled]="!supplierSelected()"
                                                                        [class.hoverable]="!supplierSelected()"
                                                                        [class.scale--hover]="supplierSelected()"
                                                                        [class.shadow--hover]="supplierSelected()"
                                                                        [class.cursor-pointer]="supplierSelected()"
                                                                        [attr.aria-disabled]="!supplierSelected()"
                                                                        [style.opacity]="!supplierSelected() ? 0.6 : 1"
                                                                        matTooltip="{{
                                                                            'Bitte zuerst einen Lieferanten auswählen, bevor Lieferscheine verknüpft werden können.'
                                                                                | translate
                                                                        }}"
                                                                        [matTooltipDisabled]="supplierSelected()"
                                                                        (click)="
                                                                            supplierSelected()
                                                                                ? openLinkDeliveryReceiptDialog(i)
                                                                                : null
                                                                        "
                                                                    >
                                                                        <div class="preview-icon">
                                                                            <em class="fas fa-info-circle"></em>
                                                                        </div>
                                                                        <div class="font-10 fw-bold">
                                                                            <em class="iim iim-delivery pe-1"></em>
                                                                            {{ 'Lieferschein' | translate }}
                                                                        </div>
                                                                        <div class="text-muted">
                                                                            {{
                                                                                'Keine Lieferungen verknüpft'
                                                                                    | translate
                                                                            }}
                                                                        </div>
                                                                    </div>
                                                                }

                                                                @if (canLinkOrder() && !itemGroup.controls.deliveryRelation.value) {
                                                                    <div
                                                                        class="receipt-preview"
                                                                        [class.hoverable]="!supplierSelected()"
                                                                        [class.scale--hover]="supplierSelected()"
                                                                        [class.shadow--hover]="supplierSelected()"
                                                                        [class.cursor-pointer]="supplierSelected()"
                                                                        [attr.aria-disabled]="!supplierSelected()"
                                                                        [style.opacity]="!supplierSelected() ? 0.6 : 1"
                                                                        matTooltip="{{
                                                                            (supplierSelected()
                                                                                ? 'Bestellposition verknüpfen'
                                                                                : 'Bitte zuerst einen Lieferanten auswählen, bevor Bestellpositionen verknüpft werden können.'
                                                                            ) | translate
                                                                        }}"
                                                                        (click)="openLinkOrderDialog(i)"
                                                                    >
                                                                        <div class="preview-icon">
                                                                            <em class="fas fa-info-circle"></em>
                                                                        </div>
                                                                        @if (itemGroup.controls.orderRelation.value) {
                                                                            <div class="actions">
                                                                                <div
                                                                                    class="edit text-primary hoverable"
                                                                                    [title]="'Bestellposition Verknüpfung bearbeiten' | translate"
                                                                                    (click)="$event.preventDefault(); $event.stopPropagation(); openLinkOrderDialog(i)"
                                                                                    matRipple
                                                                                >
                                                                                    <em class="fas fa-pen"></em>
                                                                                </div>
                                                                                <div
                                                                                    class="remove text-danger hoverable"
                                                                                    [title]="'Bestellposition Verknüpfung löschen' | translate"
                                                                                    (click)="$event.preventDefault(); $event.stopPropagation(); removeOrderRelation(i)"
                                                                                    matRipple
                                                                                >
                                                                                    <em class="fas fa-trash"></em>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        <div class="font-10 fw-bold">
                                                                            <em class="fas fa-tags pe-1"></em>
                                                                            {{ 'Bestellung' | translate }}
                                                                        </div>
                                                                        @if (itemGroup.controls.orderRelation.value; as orderRelation) {
                                                                            <div>
                                                                                <strong>{{ 'Nummer' | translate }}:</strong>
                                                                                <span copyToClipboard>{{
                                                                                    orderRelation.orderErpNumber || orderRelation.orderId
                                                                                }}</span>
                                                                            </div>
                                                                            @if (orderRelation.orderItemPosition) {
                                                                                <div>
                                                                                    <strong>{{ 'Position' | translate }}:</strong>
                                                                                    {{ orderRelation.orderItemPosition }}
                                                                                </div>
                                                                            }
                                                                        } @else {
                                                                            <div class="text-muted">
                                                                                {{ 'Keine Bestellposition verknüpft' | translate }}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col">
                                                                <label class="fw-bold">
                                                                    {{ 'Beschreibung' | translate }}
                                                                </label>
                                                                <textarea
                                                                    formControlName="description"
                                                                    rows="5"
                                                                    [placeholder]="'Beschreibung' | translate"
                                                                    class="form-control"
                                                                ></textarea>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-md-6 col-sm-12 mb-1">
                                                                <label class="fw-bold">
                                                                    {{ 'Artikelnummer Lieferant' | translate }}
                                                                </label>
                                                                <input
                                                                    formControlName="supplierArticleNumber"
                                                                    [placeholder]="
                                                                        'Artikelnummer Lieferant' | translate
                                                                    "
                                                                    class="form-control"
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3 mb-2 align-items-end">
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Menge' | translate }}
                                                                </label>
                                                                <iim-decimal-input-v2
                                                                    formControlName="quantity"
                                                                    [alwaysShowFractions]="true"
                                                                    [noOfDecimalDigits]="6"
                                                                    [showPlusMinusBtn]="true"
                                                                ></iim-decimal-input-v2>
                                                            </div>
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Bestelleinheit' | translate }}
                                                                </label>
                                                                <unit-selection
                                                                    formControlName="productUnit"
                                                                    [removable]="false"
                                                                ></unit-selection>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3 mb-2">
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Inhalt pro Bestelleinheit' | translate }}
                                                                </label>
                                                                <iim-decimal-input-v2
                                                                    formControlName="contentUnitsPerOrderUnit"
                                                                    [alwaysShowFractions]="true"
                                                                    [noOfDecimalDigits]="6"
                                                                    [showPlusMinusBtn]="true"
                                                                ></iim-decimal-input-v2>
                                                            </div>
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Inhaltseinheit' | translate }}
                                                                </label>
                                                                <unit-selection
                                                                    formControlName="contentUnit"
                                                                    [removable]="false"
                                                                ></unit-selection>
                                                            </div>
                                                        </div>
                                                        <div class="row mb-2">
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Einzelpreis' | translate }}
                                                                </label>
                                                                <div class="d-flex align-items-center">
                                                                    <iim-decimal-input-v2
                                                                        formControlName="unitPrice"
                                                                        [alwaysShowFractions]="true"
                                                                        [noOfDecimalDigits]="6"
                                                                        [showPlusMinusBtn]="true"
                                                                        [allowNegativeValues]="true"
                                                                        [emitOnType]="true"
                                                                        [disabled]="
                                                                            !!itemGroup.controls.deliveryRelation.value &&
                                                                            receiptBasedPriceFieldsReadOnly()
                                                                        "
                                                                    ></iim-decimal-input-v2>
                                                                </div>
                                                            </div>
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Währung' | translate }}
                                                                </label>
                                                                <div class="d-flex align-items-center">
                                                                    <span class="form-control bg-light text-muted">
                                                                        {{ selectedCurrencyDisplay() }}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Preismenge' | translate }}
                                                                    <i
                                                                        class="bi bi-info-circle ms-1"
                                                                        [matTooltip]="
                                                                            'Mengeneinheit, für die der Einzelpreis gilt (z.B. 100 bedeutet: Preis pro 100 Einheiten). Standard: 1.'
                                                                                | translate
                                                                        "
                                                                    ></i>
                                                                </label>
                                                                <iim-decimal-input-v2
                                                                    formControlName="priceQuantity"
                                                                    [alwaysShowFractions]="false"
                                                                    [noOfDecimalDigits]="2"
                                                                    [showPlusMinusBtn]="true"
                                                                    [emitOnType]="true"
                                                                    [disabled]="
                                                                        !!itemGroup.controls.deliveryRelation.value &&
                                                                        receiptBasedPriceFieldsReadOnly()
                                                                    "
                                                                ></iim-decimal-input-v2>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Rabatt' | translate }} %
                                                                    <i 
                                                                        class="bi bi-info-circle ms-1" 
                                                                        [matTooltip]="'Der Rabatt wird vom Einzelpreis abgezogen und reduziert den Positionsbetrag' | translate"
                                                                    ></i>
                                                                </label>
                                                                <iim-decimal-input-v2
                                                                    formControlName="discountPercentage"
                                                                    [alwaysShowFractions]="true"
                                                                    [noOfDecimalDigits]="2"
                                                                    [showPlusMinusBtn]="true"
                                                                    [emitOnType]="true"
                                                                    [disabled]="
                                                                        !!itemGroup.controls.deliveryRelation.value &&
                                                                        receiptBasedPriceFieldsReadOnly()
                                                                    "
                                                                ></iim-decimal-input-v2>
                                                            </div>
                                                        </div>
                                                        <div class="row align-items-center mb-2">
                                                            <div class="col-auto">
                                                                <label class="fw-bold">
                                                                    {{ 'Steuer' | translate }} %
                                                                </label>
                                                                <iim-decimal-input-v2
                                                                    formControlName="taxInPercent"
                                                                    [alwaysShowFractions]="true"
                                                                    [noOfDecimalDigits]="2"
                                                                    [showPlusMinusBtn]="true"
                                                                    [disabled]="
                                                                        !!itemGroup.controls.deliveryRelation.value &&
                                                                        receiptBasedPriceFieldsReadOnly()
                                                                    "
                                                                ></iim-decimal-input-v2>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col">
                                                                <separator>
                                                                    {{ 'Kontierung' | translate }}
                                                                </separator>
                                                                <accounting-selection-v2
                                                                    [generalLedgerAccountEditable]="
                                                                        !itemGroup.controls.deliveryRelation.value ||
                                                                        !receiptBasedAccountingFieldsReadOnly()
                                                                    "
                                                                    [costCenterEditable]="
                                                                        !itemGroup.controls.deliveryRelation.value ||
                                                                        !receiptBasedAccountingFieldsReadOnly()
                                                                    "
                                                                    [projectEditable]="
                                                                        !itemGroup.controls.deliveryRelation.value ||
                                                                        !receiptBasedAccountingFieldsReadOnly()
                                                                    "
                                                                    [customAccountAssignmentEditable]="
                                                                        !itemGroup.controls.deliveryRelation.value ||
                                                                        !receiptBasedAccountingFieldsReadOnly()
                                                                    "
                                                                    [companyCodeId]="companyCodeIdForAccounting()"
                                                                    [values]="accountingInputs[i]"
                                                                    [materialGroupId]="
                                                                        itemGroup.controls.materialGroupCode.value || null
                                                                    "
                                                                    (accountingChanged)="
                                                                        emitAccountingChanged($event, i)
                                                                    "
                                                                    (requiredFieldsCompleteChanged)="
                                                                        onAccountingValidationChange($event, i)
                                                                    "
                                                                    (generalLedgerCandidatesChanged)="
                                                                        updateGeneralLedgerCandidates(i, $event)
                                                                    "
                                                                    (materialGroupCandidateCodesChanged)="
                                                                        updateMaterialGroupCandidateCodes(i, $event)
                                                                    "
                                                                    (materialGroupRecommendationSourceLabelChanged)="
                                                                        updateMaterialGroupRecommendationSourceLabel(
                                                                            i,
                                                                            $event
                                                                        )
                                                                    "
                                                                    (materialGroupRecommendationReasonLabelChanged)="
                                                                        updateMaterialGroupRecommendationReasonLabel(
                                                                            i,
                                                                            $event
                                                                        )
                                                                    "
                                                                    (initialized)="onAccountingInit()"
                                                                ></accounting-selection-v2>
                                                                @if (!accountingValidMap.get(i)) {
                                                                    <div
                                                                        class="alert mt-2"
                                                                        [class.alert-warning]="allowSavingWithMissingFields()"
                                                                        [class.alert-danger]="!allowSavingWithMissingFields()"
                                                                    >
                                                                        <em
                                                                            class="fas fa-exclamation-triangle me-2"
                                                                        ></em>
                                                                        {{
                                                                            'Bitte füllen Sie alle erforderlichen Kontierungsfelder aus'
                                                                                | translate
                                                                        }}
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div class="row mt-3">
                                                            <div class="col-md-8 col-sm-12 mb-1">
                                                                <material-group-selection
                                                                    formControlName="materialGroupCode"
                                                                    [recommendedMaterialGroupCodes]="
                                                                        recommendedMaterialGroupCodesByIndex[i] ?? null
                                                                    "
                                                                    [recommendedSourceLabel]="
                                                                        recommendedMaterialGroupSourceLabelsByIndex[i] ??
                                                                        null
                                                                    "
                                                                    [recommendedReasonLabel]="
                                                                        recommendedMaterialGroupReasonLabelsByIndex[i] ??
                                                                        null
                                                                    "
                                                                    (valueChange)="
                                                                        onMaterialGroupValueChange($event, i)
                                                                    "
                                                                    (validationChange)="
                                                                        onMaterialGroupValidationChange($event, i)
                                                                    "
                                                                ></material-group-selection>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">
                                                            <div class="col d-flex justify-content-end">
                                                                <div class="item-total-amount-box">
                                                                    <label class="fw-bold d-block">
                                                                        {{ 'Gesamtbetrag' | translate }}
                                                                    </label>
                                                                    <span class="form-control bg-light text-muted text-end fw-semibold">
                                                                        @if (displayedItemLineTotals()[i]; as lineTotal) {
                                                                            <display-currency
                                                                                [value]="lineTotal.amount"
                                                                                [currencyCode]="lineTotal.currency"
                                                                                digitsInfo="1.2-2"
                                                                                locale="de"
                                                                            />
                                                                        } @else {
                                                                            -
                                                                        }
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                            <ng-template #itemsCardFooter>
                                <div class="col">
                                    <div class="row justify-content-center">
                                        <div class="col-auto">
                                            <button type="button" class="btn btn-outline-dark" (click)="addItem()">
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </iim-card>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="chargesCardHeader" [footer]="chanrgesCardFooter">
                            <ng-template #chargesCardHeader>
                                <h5>
                                    <em class="fas fa-square-plus pe-1"></em>
                                    {{ 'Zusatzkosten' | translate }}
                                </h5>
                            </ng-template>
                            @if (form.controls.charges.controls.length === 0) {
                                <div class="row mb-3">
                                    <div class="col">
                                        <div class="alert alert-info m-0">
                                            {{ 'Keine Zusatzkosten vorhanden' | translate }}
                                        </div>
                                    </div>
                                </div>
                            }
                            <ng-template #chanrgesCardFooter>
                                <div class="col">
                                    <div class="row justify-content-center">
                                        <div class="col-auto">
                                            <button
                                                type="button"
                                                class="btn btn-outline-dark"
                                                [disabled]="receiptBasedPriceFieldsReadOnly()"
                                                (click)="addAdditionalCost()"
                                            >
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @for (
                                    itemGroup of form.controls.charges.controls;
                                    track itemGroup.controls.id?.value ?? i;
                                    let i = $index
                                ) {
                                        <div [formGroup]="itemGroup">
                                            <div class="row mb-3">
                                                <div class="article w-100 article-additional-cost">
                                                @if (!receiptBasedPriceFieldsReadOnly()) {
                                                    <div
                                                        class="remove-position-btn border-danger scale--hover shadow--hover"
                                                        (click)="removeCharge(i)"
                                                    >
                                                        <em class="fas fa-trash text-danger"></em>
                                                    </div>
                                                }
                                                <div class="col">
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <label #additionalCostNameLabel class="fw-bold">
                                                                {{ 'Name' | translate }}
                                                            </label>
                                                            <input
                                                                errorHighlight
                                                                mark-required
                                                                [label]="additionalCostNameLabel"
                                                                formControlName="name"
                                                                [placeholder]="'Name' | translate"
                                                                class="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <label class="fw-bold">
                                                                {{ 'Beschreibung' | translate }}
                                                            </label>
                                                            <textarea
                                                                formControlName="description"
                                                                rows="5"
                                                                [placeholder]="'Beschreibung' | translate"
                                                                class="form-control"
                                                            ></textarea>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <label class="fw-bold">
                                                                {{ 'Typ' | translate }}
                                                            </label>
                                                            <mat-select
                                                                class="form-control"
                                                                formControlName="chargeType"
                                                                [placeholder]="'Typ' | translate"
                                                            >
                                                                @for (option of chargeTypeOptions; track option.value) {
                                                                    <mat-option [value]="option.value">
                                                                        {{ option.label | translate }}
                                                                    </mat-option>
                                                                }
                                                            </mat-select>
                                                        </div>
                                                    </div>
                                                    <separator></separator>
                                                    <div class="row mb-2">
                                                        <div class="col-md-6 col-sm-12 mb-1">
                                                            <label class="fw-bold">
                                                                {{ 'Artikelnummer Mandant' | translate }}
                                                            </label>
                                                            <input
                                                                formControlName="articleNumberCustomer"
                                                                [placeholder]="'Artikelnummer Mandant' | translate"
                                                                class="form-control"
                                                            />
                                                        </div>
                                                        <div class="col-md-6 col-sm-12 mb-1">
                                                            <label class="fw-bold">
                                                                {{ 'Artikelnummer Lieferant' | translate }}
                                                            </label>
                                                            <input
                                                                formControlName="articleNumberSupplier"
                                                                [placeholder]="'Artikelnummer Lieferant' | translate"
                                                                class="form-control"
                                                            />
                                                        </div>
                                                    </div>
                                                    <separator></separator>
                                                    <div class="row mb-2">
                                                        <div class="col">
                                                            <text-module-selection
                                                                formControlName="internalNote"
                                                                [category]="textModuleCategory.ORDER_CONFIRMATION"
                                                                [title]="'Kommentar' | translate"
                                                            ></text-module-selection>
                                                        </div>
                                                    </div>
                                                    <separator></separator>
                                                    <div class="row">
                                                        <div class="col-auto">
                                                            <label class="fw-bold">
                                                                {{ 'Einzelpreis' | translate }}
                                                            </label>
                                                            <iim-decimal-input-v2
                                                                formControlName="price"
                                                                [showPlusMinusBtn]="true"
                                                                [alwaysShowFractions]="true"
                                                                [noOfDecimalDigits]="6"
                                                                [allowNegativeValues]="true"
                                                                [emitOnType]="true"
                                                                [disabled]="receiptBasedPriceFieldsReadOnly()"
                                                            ></iim-decimal-input-v2>
                                                        </div>
                                                        <div class="col-auto">
                                                            <label class="fw-bold">
                                                                {{ 'Währung' | translate }}
                                                            </label>
                                                            <div class="d-flex align-items-center">
                                                                <span class="form-control bg-light text-muted">
                                                                    {{ selectedCurrencyDisplay() }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col">
                                                            <label class="fw-bold">{{ 'Steuer' | translate }} %</label>
                                                            <iim-decimal-input-v2
                                                                formControlName="taxInPercent"
                                                                [showPlusMinusBtn]="true"
                                                                [emitOnType]="true"
                                                                [disabled]="receiptBasedPriceFieldsReadOnly()"
                                                            ></iim-decimal-input-v2>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="totalsCardHeader">
                            <ng-template #totalsCardHeader>
                                <h5>
                                    <em class="fas fa-calculator pe-1"></em>
                                    {{ 'Summen' | translate }}
                                </h5>
                            </ng-template>
                            @let totals = displayedInvoiceTotals();
                            <div class="row justify-content-end">
                                <div class="col-12 col-lg-4">
                                    <div class="invoice-totals-line">
                                        <strong>{{ 'Zwischensumme (Netto)' | translate }}</strong>
                                        <span>
                                            <display-currency [value]="totals.netAmount" [currencyCode]="totals.currency" digitsInfo="1.2-2" locale="de" />
                                        </span>
                                    </div>
                                    @for (tax of totals.taxes; track tax.percent) {
                                        <div class="invoice-totals-line">
                                            <strong>
                                                {{
                                                    'zzgl. MwSt. {{percent}}%'
                                                        | translate
                                                            : {
                                                                  percent: tax.percent | number: '1.2-2' : 'de',
                                                              }
                                                }}
                                            </strong>
                                            <span>
                                                <display-currency [value]="tax.amount" [currencyCode]="totals.currency" digitsInfo="1.2-2" locale="de" />
                                            </span>
                                        </div>
                                    }
                                    <div class="invoice-totals-line invoice-totals-line--gross">
                                        <strong>{{ 'Gesamtsumme (Brutto)' | translate }}</strong>
                                        <span>
                                            <display-currency [value]="totals.grossAmount" [currencyCode]="totals.currency" digitsInfo="1.2-2" locale="de" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </iim-card>
                    </div>
                </div>

                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="attachmentCardHeader" [footer]="attachmentCardFooter">
                            <ng-template #attachmentCardHeader>
                                <div class="col">
                                    <div class="row">
                                        <div class="col">
                                            <h5>
                                                <em class="fas fa-paperclip pe-1"></em>
                                                {{ 'Anhang' | translate }}
                                            </h5>
                                        </div>
                                        <div class="col-auto">
                                            <div class="row">
                                                @if (hasPdfFileAttachments()) {
                                                    <div class="col-auto">
                                                        <button
                                                            class="btn btn-sm btn-primary"
                                                            (click)="togglePdfPreview()"
                                                        >
                                                            @if (displayPdfPreview()) {
                                                                <em class="fas fa-eye-slash pe-1"></em>
                                                                {{ 'PDF Vorschau ausblenden' | translate }}
                                                            } @else {
                                                                <em class="fas fa-eye pe-1"></em>
                                                                {{ 'PDF Vorschau' | translate }}
                                                            }
                                                        </button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <ng-template #attachmentCardFooter>
                                <div class="col">
                                    <div class="row justify-content-center">
                                        <div class="col-auto">
                                            <button
                                                type="button"
                                                class="btn btn-outline-dark"
                                                (click)="addAttachment()"
                                            >
                                                <i class="fas fa-plus"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="col">
                                <div class="row g-2">
                                    @if (form.controls.head.hasError('attachmentRequired')) {
                                        <div class="col-12">
                                            <!-- Display validation errors -->

                                            <div class="alert alert-danger">
                                                <em class="fas fa-exclamation-triangle me-2"></em>
                                                {{ 'Mindestens ein Anhang ist erforderlich' | translate }}
                                            </div>
                                        </div>
                                    }

                                    @let scannedImages = form.value.head.scannedImages.getAll('images');
                                    @if (
                                        files().length === 0 &&
                                        scannedImages.length === 0 &&
                                        !invoiceSettings()?.attachment.attachmentsMandatory
                                    ) {
                                        <div class="col-12">
                                            <div class="alert alert-info mb-0">
                                                <em class="fas fa-info-circle me-2"></em>
                                                {{ 'Es wurden keine Anhänge hinterlegt' | translate }}
                                            </div>
                                        </div>
                                    }
                                    @if (files().length > 0) {
                                        <div class="col-12 mb-3">
                                            <div class="row align-items-center g-1">
                                                @for (entry of files(); track entry) {
                                                    <div class="col-auto">
                                                        <file-download
                                                            [imagePreview]="true"
                                                            [blob]="entry"
                                                            [removable]="true"
                                                            (removeClicked)="removeFile(entry)"
                                                        ></file-download>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (scannedImages.length > 0) {
                                        <div class="col-12">
                                            <div class="row align-items-center g-1">
                                                <div class="col-12">
                                                    <label class="fw-bold">
                                                        {{ 'Scan' | translate }}
                                                    </label>
                                                </div>
                                                @for (entry of scannedImages; track entry) {
                                                    <div class="col-auto">
                                                        <scanned-image-preview
                                                            [imageData]="entry"
                                                            (removeClicked)="removeScannedImage(entry)"
                                                        ></scanned-image-preview>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </iim-card>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="commentCardHeader">
                            <ng-template #commentCardHeader>
                                <h5>
                                    <em class="fas fa-comment pe-1"></em>
                                    {{ 'Kommentar' | translate }}
                                </h5>
                            </ng-template>
                            <div class="col">
                                <div class="row mb-2">
                                    <div class="col">
                                        <textarea
                                            class="form-control"
                                            rows="5"
                                            [formControl]="form.controls.comment"
                                            [placeholder]="'Kommentar' | translate"
                                        ></textarea>
                                    </div>
                                </div>
                            </div>
                        </iim-card>
                    </div>
                </div>
                <div class="sticky-save">
                    @if (existingInvoiceId(); as invoiceId) {
                        @if (!taskId()) {
                            <div class="row mb-2">
                                <div class="col d-flex justify-content-end">
                                    <button
                                        type="button"
                                        class="btn btn-outline-dark me-2"
                                        [routerLink]="'/client/my-admin/invoice/' + invoiceId + '/detail'"
                                    >
                                        <em class="fas fa-arrow-left pe-1"></em>
                                        {{ 'zurück' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-outline-dark me-2"
                                        [disabled]="isSaveButtonDisabled()"
                                        (click)="onSaveDraft()"
                                    >
                                        <em class="fas fa-floppy-disk pe-1"></em>
                                        {{ 'Entwurf speichern' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        [disabled]="isSaveButtonDisabled()"
                                        (click)="onSaveForApproval()"
                                    >
                                        <em class="fas fa-floppy-disk pe-1"></em>
                                        {{ 'Speichern und zur Freigabe' | translate }}
                                    </button>
                                </div>
                            </div>
                        } @else if (insideDialog) {
                            @if (showIncompleteWarning()) {
                                <div class="row mb-2">
                                    <div class="col">
                                        <div class="alert alert-warning mb-0">
                                            <em class="fas fa-triangle-exclamation pe-1"></em>
                                            {{ incompleteSaveWarningText | translate }}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div class="row mb-2">
                                <div class="col d-flex justify-content-end">
                                    <button type="button" class="btn btn-secondary me-2" (click)="onDialogCancel()">
                                        <em class="fas fa-arrow-left pe-1"></em>
                                        {{ 'Abbrechen' | translate }}
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-primary"
                                        [disabled]="isSaveButtonDisabled()"
                                        (click)="onDialogUpdate()"
                                    >
                                        <em class="fas fa-floppy-disk pe-1"></em>
                                        {{ 'Rechnung aktualisieren' | translate }}
                                    </button>
                                </div>
                            </div>
                        }
                    } @else {
                        <div class="row mb-2">
                            <div class="col d-flex justify-content-end">
                                <button type="button" class="btn btn-secondary me-2" (click)="cancel()">
                                    <em class="fas fa-arrow-left pe-1"></em>
                                    {{ 'Abbrechen' | translate }}
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    [disabled]="isSaveButtonDisabled()"
                                    (click)="save()"
                                >
                                    <em class="fas fa-floppy-disk pe-1"></em>
                                    {{ 'Speichern' | translate }}
                                </button>
                            </div>
                        </div>
                    }
                </div>
                }
            }
        </div>
        @if (showPdfPreview() && !requiresCompanyCodeSelection()) {
            <div class="col-6 mt-2" *showOnDesktop>
                <div class="pdf-sticky-wrapper" [class.dialog]="insideDialog">
                    <pdf-preview [files]="files()"></pdf-preview>
                </div>
            </div>
        }
    </div>
</base-site-layout>
